export const SidebarStripe = "atlantis-sidebar-stripe";
export const SidebarStripeItem = "atlantis-sidebar-stripe-item";